<template>
  <div>
    <div class="card_form_box" v-loading="PageLoading">
      <div class="certificate">
        <div class="certificate_title">
          <p class="title_label"> 制作欧标纺织品水洗唛</p>
          <p class="title_remake">根据ISO 3758:2012制作（Textiles-Care labeling code using symbols)</p>
        </div>
        <el-form :model="ruleForm" :rules="rules"  label-position="top" ref="ruleForm" label-width="300px" class="demo-ruleForm">
          <el-row>
            <el-col :span="24">
              <el-form-item label="号型">
                <span slot="label">号&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;型</span>
                <div class="Size_pos">
<!--                  <div @click="ChangeSizeFocus(true,true)" class="Size_pos_layout">-->
<!--                  </div>-->
                  <el-input v-model="ruleForm.MODEL_TYPE"  style="width: 392px;"  maxlength="200" ></el-input>
                </div>
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item label="成分含量">
                <span slot="label">成分含量 <span class="label_tit" > (多个成分分开添加) </span></span>
                <div v-for="(domain, index) in ruleForm.COMPONENT" :key="index" style="display:flex;margin-bottom: 5px;align-items: center;">
                  <div>
                    <el-input v-model="domain.attrValue" style="width: 250px;" maxlength="50"  placeholder="请填写成分名称"></el-input>
                  </div>
                  <div class="label_number">
                    <el-input-number v-model="domain.attrRate"
                                     :controls="false"
                                     style="width: 90px;margin-left: 12px;"
                                     :precision="2"
                                     :min="0.00"
                                     :max="100"
                                     maxlength="3"
                                     @change="ChangeValue(index)"
                                     placeholder="填写百分比含量"
                    >
                    </el-input-number>
                    <div class="Symbol">
                      %
                    </div>
                  </div>
                  <div @click="addDomain" style="cursor: pointer;">
                    <img src="../../assets/images/add.png" >
                  </div>
                  <div @click.prevent="removeDomain(domain)" v-if="index !==0" style="margin-left: 10px;cursor: pointer">
                    <img src="../../assets/images/minus.png" >
                  </div>
                </div>
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item label="请选择洗涤方法">
                <span slot="label">请选择洗涤方法 <span class="label_tit" > (点击符号可选) *</span></span>
                <div class="icon_box" id="showDiv">
                  <div v-for="(item,index) in ruleForm.AllIconList" :key="index" class="icon_box_list" >
                    <div class="icon_name">
                      <span>{{item.iconName}}</span>
                      <span v-if="item.multiple">(可多选)</span>
                    </div>
                    <div class="check_icon" @click="ChangeIcon(item,index)" id="showImgBox">
                      <!--                      <div v-if="item.checkIcon.length>0" class="check_img">-->
                      <!--                        <img :src="item.checkIcon[0].enumName" alt=""  />-->
                      <!--                      </div>-->
                      <div v-for="(y,ind) in item.checkIcon" :key="ind" class="check_img">
                        <img :src="y.enumName" alt=""  />
                      </div>
                    </div>
                    <!--                    <div class="Optional_icon" v-if="item.CheckShow"  ref="box">-->
                    <!--                      <div>-->
                    <!--                        <div v-for="(s,ind2) in item.AllIconList" :key="ind2" class="Optional_icon_list"  @click="AddCheckIcon(item,s,index)">-->
                    <!--                          <div class="optional_img">-->
                    <!--                            <img :src="s.enumName" alt=""  />-->
                    <!--                          </div>-->
                    <!--                          <div :class="{'optional_remake':true,'Active_Remake':GetActive(item.checkIcon,s.configId)}">-->
                    <!--                            {{s.remark}}-->
                    <!--                          </div>-->
                    <!--                        </div>-->
                    <!--                      </div>-->
                    <!--                    </div>-->

                  </div>
                </div>
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item label="请选择展示模式">
                <span slot="label">请选择展示模式 <span>（不同展示模式的效果请见右侧预览）</span></span>
                <el-radio-group v-model="ruleForm.showMode">
                  <el-radio :label="1">图片和文字模式</el-radio>
                  <el-radio :label="2">纯图片模式</el-radio>
                  <el-radio :label="3">纯文字模式</el-radio>
                </el-radio-group>
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item label="洗涤提醒">
                <el-input
                    type="textarea"
                    placeholder="如有警示语，请填写"
                    v-model="ruleForm.textarea"
                    maxlength="200"
                    :autosize="{ minRows: 4, maxRows: 6}"
                    style="width: 852px;"
                >
                </el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
<!--        <SizeModelBox :SizeDialogVisible="SizeDialogVisible" :LocalKey="LocalKey" @ChangeSizeFocus="ChangeSizeFocus" :apiHost="apiHost"></SizeModelBox>-->
      </div>
    </div>
    <el-dialog
        title=""
        :visible.sync="dialogVisible"
        width="800px">
      <div slot="title" class="header-title">
        <span  class="name">
          请选择洗涤方法  <span class="name_tit" v-if="this.IconList.multiple">（最多选2个）</span>
        </span>
      </div>
      <div class="Optional_icon" >
        <div v-for="(s,ind2) in IconList.AllIconList" :key="ind2" class="Optional_icon_list"  @click="AddCheckIcon(s)">
          <div class="optional_check">
            <div v-if="GetActive(IconList.checkIcon,s.configId)" class="optional_check_icon">
              <img src="../../assets/images/check_true.png" />
            </div>
            <div v-else class="optional_check_icon">
              <img src="../../assets/images/check_false.png" />
            </div>
          </div>
          <div class="optional_text">
            <div class="optional_img">
              <img :src="s.enumName" alt=""  />
            </div>
            <div :class="{'optional_remake':true}">
              <!--                'Active_Remake':GetActive(IconList.checkIcon,s.configId)-->
              {{s.remark}}
            </div>
          </div>

        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="addIcon">确 定</el-button>
      </span>
    </el-dialog>
  </div>


</template>

<script>

// import SizeModelBox from "./SizeModel/SizeModelBox";
import {GetProductBatch, qryEUMakeToolRecord, saveMakeToolRecordEUR} from "src/request/apis";
import Cookies from "js-cookie";

export default {
  name: "WashingMarkForm2",
  components:{
    // SizeModelBox,
  },
  props: {
    rowNum:{
      type:Number,
      default:24
    },
    CheckFormPass:{
      type:Function,
      default:null
    },
    CloseLoading:{
      type:Function,
      default:null
    },
    GetData:{
      type:Function,
      default:null
    },
    JumpPersonalCenter:{
      type: String,
      default: ()=>''
    },
    apiHost: {
      type: String,
      default: ()=>''
    }
  },
  data() {
    return {
      checked: true,
      dialogVisible: false,
      PageLoading:false,
      SizeDialogVisible:false,
      LocalKey:'WashSelectTypeSize',
      firstSizeValue:'',//第一個好型
      IconList:{},
      IconListIndex:0,
      ruleForm: {
        MODEL_TYPE: '',
        COMPONENT: [],
        textarea:'',
        showMode:1,
        AllIconList:[]
      },
      rules: {
        MODEL_TYPE: [
          { required: true, message: '请输入号型规格', trigger: 'blur' },
        ],
      },
      AllIconType:[
        {
          name:'水洗',
          iconKey:'ICON.SL_WATER_EUR',
          multiple:false
        },
        {
          name:'漂白',
          iconKey:'ICON.SL_BLEACH_EUR',
          multiple:false
        },
        {
          name:'干燥',
          iconKey:'ICON.SL_DRY_EUR',
          multiple:true
        },
        {
          name:'熨烫',
          iconKey:'ICON.SL_IRONING_EUR',
          multiple:false
        },
        {
          name:'干洗',
          iconKey:'ICON.SL_DRY_CLEAN_EUR',
          multiple:true
        }
      ],
      currenticonlist:[],
      history:{},
      GetIconListValue:[
        {
          tableName:'ICON',
          colName:'SL_WATER_EUR'
        },
        {
          tableName:'ICON',
          colName:'SL_BLEACH_EUR'
        },
        {
          tableName:'ICON',
          colName:'SL_DRY_EUR'
        },
        {
          tableName:'ICON',
          colName:'SL_IRONING_EUR'
        },
        {
          tableName:'ICON',
          colName:'SL_DRY_CLEAN_EUR'
        }
      ]

    };
  },
  watch:{
    ruleForm:{
      handler(newVal){
        let data=[
          {
            label:'Size',
            value:newVal.MODEL_TYPE,
            required: false
          },
          {
            label:'Fiber Content',
            value:this.ComponentContent(newVal.COMPONENT),
            required: false,
          },
          {
            label:'Washing Instructions',
            value:newVal.AllIconList,
            typeImg:true,
            required: true,
            showMode:newVal.showMode
          },
          {
            label:'洗涤提醒',
            value:newVal.textarea,
            required: false,
          }
        ]
        this.GetData(data)
        let form=this.WashFormData()
        let accessToken = Cookies.get('SSO_TOKEN')
        if(form&&accessToken) localStorage.setItem('label4',JSON.stringify(form))

      },
      deep:true
    }
  },
  mounted() {
    this.GetProductList(this.GetIconListValue)
  },
  created() {
    this.$nextTick(()=>{
      document.addEventListener("click", e => {
        let list = document.getElementById("showDiv");
        if (list&&list.contains(e.target)) {
        } else {
          this.ruleForm.AllIconList.map((v,index)=>{
            this.$set(this.ruleForm.AllIconList[index],'CheckShow',false)
          })
        }
      })
    })
  },
  methods: {
    GetActive(list,id){
      return list.some(item => {
        if (item.configId === id) {
          return true
        }
      })
    },
    //获取历史form数据
    GetFormList(AllIconList){
      this.PageLoading=true
      let that=this
      qryEUMakeToolRecord({
        toolCode:'SL_TOOLKIT005',
        makeType:"100"
      },that.apiHost).then(res=>{
        if(res&&res.data){
          let list=res.data
          this.AssembleFormData(list, AllIconList)
        }else{
          let tempFrom = {
            AllIconList : AllIconList,
            textarea: '',
            MODEL_TYPE: '',
            showMode:1,
            COMPONENT: [
              {
                attrValue:'',
                attrRate:''
              }
            ]
          }
          this.ruleForm = JSON.parse(JSON.stringify((tempFrom)))
        }
        that.PageLoading=false
      }).catch(err=>{
        if(err.resultCode==='6001'){
          that.$router.push({
            path:that.JumpPersonalCenter
          })
        }
        that.PageLoading=false
      })
    },
    //处理缓存form数据  或者后端返回数据
    AssembleFormData(arr,AllIconList){
      let list=arr.normalList
      let tempFrom = {
        AllIconList : AllIconList,
        textarea: '',
        MODEL_TYPE:'',
        showMode:Number(arr.showMode) || 1,
        COMPONENT: [
          {
            attrValue:'',
            attrRate:''
          }
        ]
      }
      list.forEach((item, itemIndex)=>{
        if(item.attrCode==='NOTES'){
          tempFrom.textarea= item.attrValue
        }else if(item.attrCode==='MODEL_TYPE'){
          tempFrom.MODEL_TYPE= item.attrValue
        }else if(item.attrCode==='COMPONENT'){
          let arr=[]
          item.items.forEach(s=>{
            arr.push({
              attrRate: s.attrRate,
              attrValue: s.attrValue
            })
          })
          tempFrom.COMPONENT=arr
        }else{
          tempFrom.AllIconList.forEach((s,index)=>{
            if (item.attrCode !== 'ICON') {
              if (s.iconKey===item.attrCode){
                let arr=[]
                let arr1
                item.items.filter(obj => arr.push(obj.attrValue))
                arr1 = s.AllIconList.filter(obj => arr.indexOf(obj.enumCode) !== -1)
                if(arr1){
                  tempFrom.AllIconList[index]['checkIcon'] = arr1
                }else{
                  tempFrom.AllIconList[index]['checkIcon'] = s.AllIconList[0]
                }
              }
            } else {
              item.items.forEach(v1 => {
                tempFrom.AllIconList.forEach(v2 => {
                  if (v1.iconKey === v2.iconKey && v2.checkIcon.length)
                    v2.checkIcon = v1.checkIcon
                })
              })
            }
          })
        }
      })
      this.ruleForm = JSON.parse(JSON.stringify((tempFrom)))
      let fromUrl=this.$route.query.fromPage
      if(fromUrl){
        this.ruleForm.COMPONENT=JSON.parse(localStorage.getItem('WashSelectTypeSize')).Ingredients
      }
    },
    //点击图标显示图标列表
    ChangeIcon(item,ind){
      this.IconList=JSON.parse(JSON.stringify(item))
      this.dialogVisible=true
      this.IconListIndex=ind
    },
    //追加图标
    AddCheckIcon(s){
      if(!this.IconList.multiple){
        //单选
        this.$set(this.IconList.checkIcon,0,s)
      }else{
        let currentList=this.IconList.checkIcon
        let ind=currentList.findIndex(v=>{
          return  v.configId===s.configId
        })
        if(ind>=0){
          if(this.IconList.checkIcon.length===1){
            this.$message('最少选择1个')
          }else {
            currentList.splice(ind,1)
          }
        }else{
          if(currentList.length<2){
            currentList.push(s)
          }else{
            this.$message('最多可选2个')
          }
        }
        this.$set(this.IconList,'checkIcon',currentList)
      }
    },
    addIcon(){
      this.$set(this.ruleForm.AllIconList,this.IconListIndex,this.IconList)
      this.dialogVisible=false
    },
    //成分含量解构
    ComponentContent(list){
      let arr=[]
      if(list){
        list.forEach(item=>{
          if(item.attrValue){
            arr.push(`<div>${item.attrValue} ${item.attrRate}%</div>`)
          }
        })
      }
      return arr.join('')
    },
    //统计号型总数
    // SizeTotal(){
    //   let SelectTypeSize=JSON.parse(localStorage.getItem(this.LocalKey))
    //   let num=0
    //   let str=''
    //   let num1=''
    //   let num0=''
    //   if(SelectTypeSize&&SelectTypeSize.Size){
    //     SelectTypeSize.Size.forEach(item=>{
    //       if(item.name !=='OtherProducts'){
    //         num+=item.list.length
    //       }else{
    //         str=item.list
    //       }
    //     })
    //     let arr=SelectTypeSize.Size.find(item=>{
    //       if(item.name !=='OtherProducts'){
    //         return item.list.length>0
    //       }
    //     })
    //     // if(arr){
    //     //   num0=arr.list[0].typeValue
    //     // }
    //     // if(num>1){
    //     //   num1=`共计${num}种号型`
    //     // }else{
    //     //   if(arr){
    //     //     num1=num0
    //     //   }else{
    //     //     num1=''
    //     //   }
    //     // }
    //     // this.$set(this.ruleForm,'firstSizeValue',num0+` ${str?`(其他产品:${str})`:''}`)
    //     // this.$set(this.ruleForm,'MODEL_TYPE',num1+` ${str?`(其他产品:${str})`:''}`)
    //     if(arr){
    //       num0=arr.list[0].typeValue
    //     }
    //     if(num>1){
    //       num1=`共计${num}种号型`
    //     }else{
    //       if(arr){
    //         num1=num0
    //       }else{
    //         num1=''
    //       }
    //     }
    //     if(num0){
    //       this.$set(this.ruleForm,'firstSizeValue',num0)
    //     }else {
    //       this.$set(this.ruleForm,'firstSizeValue',` ${str?`其他产品:${str}`:''}`)
    //     }
    //     if(num1){
    //       this.$set(this.ruleForm,'MODEL_TYPE',num1+` ${str?`(其他产品:${str})`:''}`)
    //     }else{
    //       this.$set(this.ruleForm,'MODEL_TYPE',` ${str?`其他产品:${str}`:''}`)
    //     }
    //   }
    // },
    //获取号型
    // ChangeSizeFocus(val,type){
    //   if(!type&&this.history){
    //     localStorage.setItem(this.LocalKey, JSON.stringify(this.history))
    //   }else{
    //     this.history=JSON.parse(localStorage.getItem(this.LocalKey))
    //   }
    //   this.SizeDialogVisible=val
    // },
    ChangeValue(index){
      let data=this.ruleForm.COMPONENT
      this.$nextTick(() => {
        // data[index].attrRate=parseInt(data[index].attrRate)
        data=parseFloat(data)
        data[index].attrRate=parseFloat(data.toFixed(2))
      })
    },
    //验证成分含量
    CheckComponentContent(){
      let data=this.ruleForm.COMPONENT
      let isEmpty=true //是否所有输入框填写
      let isContent=true //含量100
      if(data.length===1&&data[0].attrValue===''&& !data[0].attrRate){
        this.FormatFormData()
      }else{
        for(let i in data){
          let object=data[i]
          for (const key in object) {
            if (object.hasOwnProperty(key)) {
              if (object[key] === null || object[key] === '') {
                isEmpty=false
                break
              }else{
                isEmpty=true
              }
            }
          }
        }
        if(isEmpty){
          let sum=0
          for(let i in data){
            sum+=Number(data[i].attrRate)
          }
          if(sum !==100){
            isContent=false
          }
        }
        if(!isEmpty){
          this.CloseLoading()
          return this.$message({
            message: '请填写成分含量',
            type: 'warning'
          });
        }
        if(!isContent){
          this.CloseLoading()
          return this.$message({
            message: '成分含量的合计应为100%，请重新输入',
            type: 'warning'
          });
        }
        if(isEmpty&&isContent){
          this.FormatFormData()
        }
      }
    },
    //获取图片枚举值
    GetProductList(data){
      GetProductBatch(data,this.apiHost).then((res) => {
        let AllIconList=[]
        if(res&&res.data){
          for (let item of Object.keys(res.data)){
            let s=this.AllIconType.find(y => y.iconKey === item)
            if(s){
              AllIconList.push({
                iconName:s.name,
                iconKey:item,
                AllIconList:res.data[item],
                checkIcon:[res.data[item][0]],
                CheckShow:false,
                multiple:s.multiple
              })
            }
          }
          let list=JSON.parse(localStorage.getItem('label4'))
          if(list){
            this.AssembleFormData(list,AllIconList)
          }else{
            this.GetFormList(AllIconList)
          }
        }
      }).catch((e) => {
        this.loading = false
      })
    },
    //处理回传数据库数据格式
    WashFormData(){
      let {
        COMPONENT,
        AllIconList,
        textarea,
        MODEL_TYPE,
        showMode
      }=this.ruleForm
      return {
        toolCode: "SL_TOOLKIT005",
        makeType: "100",
        state: 1,
        showMode:showMode,
        normalList: [
          {
            attrName: "成分含量",
            attrCode: "COMPONENT",
            items: COMPONENT
          },
          {
            attrName: "号型规格",
            attrCode: "MODEL_TYPE",
            attrValue: MODEL_TYPE || ''
          },
          {
            attrName: "洗涤方法",
            attrCode: "ICON",
            items: AllIconList
          },
          {
            attrName: "洗涤提醒",
            attrCode: "NOTES",
            attrValue: textarea
          }
        ]
      }
    },
    //处理保存数据
    FormatFormData(){
      let FormData=this.WashFormData()
      saveMakeToolRecordEUR(FormData,this.apiHost).then((res) => {
        if(res&&res.resultCode==='0'){
          this.$message.success('保存成功，下载中......');
          this.CheckFormPass()
          localStorage.removeItem('label4')
        }else{
          this.$message.error(res.resultMsg);
        }
      }).catch((e) => {

      })
    },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.CheckComponentContent()
        } else {
          this.CloseLoading()
          this.$message('请填写必填项后再下载');
          return false;
        }
      });
    },
    removeDomain(item) {
      let index = this.ruleForm.COMPONENT.indexOf(item)
      if (index !== -1) {
        this.ruleForm.COMPONENT.splice(index, 1)
      }
    },
    addDomain() {
      this.ruleForm.COMPONENT.push({
        attrValue: '',
        attrRate:'',
        key: Date.now()
      });
    }
  }
}
</script>

<style lang="scss" scoped>
.card_form_box{
  display: flex;
  background: #FFFFFF;
  padding-left: 31px;
  padding-top: 20px;
  .certificate {
    flex: 1;
    .certificate_title {
      .title_label {
        font-size: 30px;
        font-weight: 400;
        color: #333333;
        text-align: center;
        margin-bottom: 20px;
      }

      .title_remake {
        font-size: 14px;
        font-weight: 400;
        color: #333333;
        margin-bottom: 20px;
      }

    }
    .label_tit{
      font-size: 14px;
      color: #FF0000;
      font-weight: 500;
    }
    .label_number{
      display: flex;
      margin-right: 10px;
      .Symbol{
        width: 40px;
        height: 40px;
        border: 1px solid #cccccc;
        background: #f5f7fa;
        text-align: center;
        border-left: none;
        border-top-right-radius: 4px;
        border-bottom-right-radius: 4px;
        color: #747474;
      }
    }
  }
}

.Size_pos{
  position: relative;
  margin-bottom: 40px;
  .Size_pos_layout{
    position: absolute;
    width: 392px;
    height: 40px;
    z-index: 1;
  }
  .el-input{
    position: absolute;
    z-index: 0;
  }
}
.icon_box{
  display: flex;
  border: 1px solid #D2D2D2;
  border-radius: 5px 0px 0px 5px;
  width: 849px;
  .icon_box_list{
    display: flex;
    flex-direction: column;
    width: 170px;
    height: 128px;
    .icon_name{
      height: 45px;
      background: #F6F6F6;
      border-bottom: 1px solid #D2D2D2;
      border-right:1px solid #D2D2D2;
      text-align: center;
    }
    .check_icon{
      position: relative;
      display: flex;
      width: 169px;
      height: 83px;
      border-right:1px solid #D2D2D2;
      justify-content: center;
      align-items: center;
      cursor: pointer;
      .check_img{
        width: 48px;
        height: 48px;
        margin-right: 9px;
        img{
          width: 48px;
          height: 48px;
        }
      }
    }

  }
  .icon_box_list:first-child .icon_name{
    border-radius: 5px 0 0 0;
  }
  .icon_box_list:last-child .icon_name{
    border-right: none;
  }
  .icon_box_list:last-child .check_icon{
    border-right: none;
  }
}
.header-title{
  .name{
    font-size: 18px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #333333;
    .name_tit{
      font-size: 14px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: #FF0000;
    }
  }
}
.Optional_icon{
  border-top: 1px solid #D2D2D2;
  border-left: 1px solid #D2D2D2;
  width: 755px;
  display: flex;
  flex-wrap: wrap;
  .Optional_icon_list{
    display: flex;
    align-items: center;
    border-bottom:1px solid #D2D2D2;
    border-right:1px solid #D2D2D2;
    height: auto;
    min-height: 45px;
    cursor: pointer;
    width: 376px;
    .optional_check{
      width: 60px;
      height: 100%;
      border-right: 1px solid #D2D2D2;
      position: relative;
      .optional_check_icon{
        display: flex;
        justify-content: center;
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
      }
    }
    .optional_text{
      display: flex;
      padding: 0 30px;
      width: 316px;
      align-items: center;
      .optional_img{
        width: 30px;
        height: 30px;
        margin-right: 15px;
        img{
          width: 30px;
          height: 30px;
          object-fit: cover;
        }
      }
      .optional_remake{
        display: flex;
        align-items: center;
        line-height: 16px;
      }
      .Active_Remake{
        color: #CA4300;
      }
    }

  }
  .Optional_icon_close{
    position: absolute;
    top: -22px;
    right: -4px;
    cursor: pointer;
  }
}
::v-deep .label_number .el-input__inner{
  border-top-right-radius: 0 !important;
  border-bottom-right-radius: 0 !important;
}
::v-deep .el-form-item__label{
  color: #333333;
  font-weight: bold;
  padding: 10px 0 20px 0;
  line-height: 0;
}
::v-deep .el-form-item{
  margin-bottom: 16px;
}
</style>